module.exports = __webpack_public_path__ + "img/manajemen_moda.477add31.svg";